import type { EditorCommand } from '@atlaskit/editor-common/types';

import type {
	AllowedAIEvents,
	CompleteAIEvent,
	StreamAIEvent,
	ErrorAIEvent,
} from '../../editor-actions/types';

import { createCommand } from './ai-experience-context-plugin';

export const resetExperience = (): EditorCommand =>
	createCommand({
		type: 'RESET',
	});

export const streamADFResponse = ({ adfResponse }: StreamAIEvent): EditorCommand =>
	createCommand({ type: 'STREAM', adfResponse });

export const completeExperience = ({ adfResponse }: CompleteAIEvent): EditorCommand =>
	createCommand({ type: 'COMPLETE', adfResponse });

export const errorExperience = ({ errorInfo }: ErrorAIEvent): EditorCommand =>
	createCommand({ type: 'ERROR', errorInfo });

export const dispatchAllowedAIEvent = (event: AllowedAIEvents): EditorCommand | undefined => {
	switch (event.type) {
		case 'stream':
			return streamADFResponse(event);
		case 'complete':
			return completeExperience(event);
		case 'error':
			return errorExperience(event);
		default:
			return;
	}
};
